// Deterministic palette for tag chips. Colors are picked by hashing the
// tag label so the same tag always gets the same color across the app
// (table cells, the Add Tags form, row detail) regardless of position
// in any given row.

export const TAG_COLOR_PALETTE = [
  { bg: "#E3F2FD", border: "#1976D2", text: "#0D47A1" }, // blue
  { bg: "#F3E5F5", border: "#8E24AA", text: "#4A148C" }, // purple
  { bg: "#E8F5E9", border: "#388E3C", text: "#1B5E20" }, // green
  { bg: "#FFF3E0", border: "#F57C00", text: "#E65100" }, // orange
  { bg: "#FCE4EC", border: "#D81B60", text: "#880E4F" }, // pink
  { bg: "#E0F7FA", border: "#0097A7", text: "#006064" }, // cyan
  { bg: "#FFFDE7", border: "#FBC02D", text: "#827717" }, // yellow
  { bg: "#EDE7F6", border: "#5E35B2", text: "#311B92" }, // deep purple
  { bg: "#FFEBEE", border: "#E53935", text: "#B71C1C" }, // red
  { bg: "#E0F2F1", border: "#00897B", text: "#004D40" }, // teal
  { bg: "#F1F8E9", border: "#7CB342", text: "#33691E" }, // light green
  { bg: "#EFEBE9", border: "#6D4C41", text: "#3E2723" }, // brown
];

const hashString = (input: string): number => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 31 + input.charCodeAt(i)) | 0;
  }
  return Math.abs(hash);
};

export const getTagColor = (tag: string) => {
  const key = (tag || "").trim().toLowerCase();
  if (!key) return TAG_COLOR_PALETTE[0];
  return TAG_COLOR_PALETTE[hashString(key) % TAG_COLOR_PALETTE.length];
};
